import BasePayload from "../payloads/base-payload.ts";

export default class PendingPayload {
  /**
   * The number of milliseconds to wait before considering a pending payload 'expired'.
   * @private
   */
  private static readonly expirationDurationMilliseconds: number = 1000 * 5; // 5 seconds

  /**
   * The payload's ID.
   */
  public readonly id: string;
  /**
   * The payload's OutgoingPayloadEvent variant.
   */
  public readonly event: string;
  /**
   * The time, in milliseconds (since epoch), that the payload was sent out.
   */
  private readonly startTimeMilliseconds: number;

  constructor(payload: BasePayload) {
    this.id = payload.id;
    this.event = payload.event;
    this.startTimeMilliseconds = Date.now();
  }

  public isExpired(currentTimeMilliseconds: number): boolean {
    return currentTimeMilliseconds - this.startTimeMilliseconds > PendingPayload.expirationDurationMilliseconds;
  }
}
